import { render } from "./glob-dropdown-multiselect.vue?vue&type=template&id=88276f94"
import script from "./glob-dropdown-multiselect.vue?vue&type=script&lang=js"
export * from "./glob-dropdown-multiselect.vue?vue&type=script&lang=js"

import "./glob-dropdown-multiselect.vue?vue&type=style&index=0&id=88276f94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__